var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h1',{staticClass:"mt-2"},[_vm._v("JSON Tools")]),_c('JSON')],1)}
var staticRenderFns = []

export { render, staticRenderFns }